<header class="absolute inset-x-0 top-0 z-20">
  <nav class="mx-auto flex max-w-7xl items-center justify-between p-6 lg:px-8" aria-label="Global">
    <div class="flex lg:flex-1">
      <a href="#" class="-m-1.5 p-1.5">
        <span class="sr-only">Hagile</span>
        <hg-logo></hg-logo>
      </a>
    </div>
    <div *ngIf="hasMobileMenu" class="flex lg:hidden">
      <button type="button" class="-m-2.5 inline-flex items-center justify-center rounded-md p-2.5 text-gray-700" (click)="toggleMenu()">
        <span class="sr-only">Open main menu</span>
        <svg class="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" aria-hidden="true">
          <path stroke-linecap="round" stroke-linejoin="round" d="M3.75 6.75h16.5M3.75 12h16.5m-16.5 5.25h16.5" />
        </svg>
      </button>
    </div>
    <div class="hidden lg:block">
      <ng-content select="[menuItemsSlot]"></ng-content>
    </div>
    <div class="hidden lg:flex lg:flex-1 lg:justify-end">
      <ng-content select="[menuButtonsSlot]"></ng-content>
    </div>
  </nav> 

  <!-- Mobile menu, show/hide based on menu open state. -->
  <div *ngIf="mobileMenuOpen" class="lg:hidden" role="dialog" aria-modal="true">
    <div class="fixed inset-0 z-10"></div>
    <div class="fixed inset-y-0 right-0 z-30 w-full overflow-y-auto bg-white px-6 py-6 sm:max-w-sm sm:ring-1 sm:ring-gray-900/10">
      <div class="flex items-center justify-between">
        <a href="#" class="-m-1.5 p-1.5">
          <span class="sr-only">Hagile</span>
          <hg-logo></hg-logo>
        </a>
        <button type="button" class="-m-2.5 rounded-md p-2.5 text-gray-700" (click)="toggleMenu()">
          <span class="sr-only">Close menu</span>
          <svg class="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" aria-hidden="true">
            <path stroke-linecap="round" stroke-linejoin="round" d="M6 18L18 6M6 6l12 12" />
          </svg>
        </button>
      </div>
      <div class="mt-6 flow-root">
        <div class="-my-6 divide-y divide-gray-500/10">
          <div class="space-y-2 py-6">
            <ng-content select="[mobileMenuItemsSlot]"></ng-content>
          </div>
          <div class="py-6">
            <ng-content select="[menuButtonsSlot]"></ng-content>
          </div>
        </div>
      </div>
    </div>
  </div>
</header>





  